/**
 *  desc-error
 */

/**
 * create error message
 * @param {string} msg error msg to display
 * @param {string} id msg error id
 * @return {jQuery} msg jQuery object
 */
function create(msg, id, cssClass) {
  return $(`<div id="${id}" class="m-form-control m-form-control--error ${cssClass}">`
    + '<i class="a-icon-css a-icon-css--error-form m-desc-error__icon" aria-hidden="true"></i>'
    + `<span class="m-form-control__text a-text a-text--error" id="error">${msg}</span>`
  + '</div>');
}

/**
 * add error message in DOM
 * @param {string} msg error msg to display
 * @param {string} id msg error id
 * @param {string} elem elem in Dom
 * @param {string} position before, after, top, bottom
 */
function addMsg(msg, id, cssClass, elem, position = 'before') {
  /*
  if (msg.length === 0) {
    return false;
  }
  */

  const $elem = $(elem);
  const $msg = create(msg, id, cssClass);

  switch (position) {
    case 'after': {
      $elem.after($msg);
      break;
    }
    case 'append':
    case 'bottom': {
      $elem.append($msg);
      break;
    }
    case 'prepend':
    case 'top': {
      $elem.prepend($msg);
      break;
    }
    case 'before':
    default: {
      $elem.before($msg);
      break;
    }
  }

  return true;
}

export {
  addMsg,
};

export default addMsg;



// WEBPACK FOOTER //
// ./js/common/molecule/desc-error.js